/* eslint-disable eqeqeq */
// this function's job is to make sure we update the user's YMM if the one that appears in the url is different than the current state
export default async function ({ route, store, error, res }) {
    // since route.meta is a nuxty array of metas from page comps, we have to look at the meta from matched.
    const meta = route.matched[route.matched.length - 1].meta

    if (route.params.makeSlug) {
        // if the M/MM/YMM is diff from current, setup the session
        if (
            route.params.year != store.state.fitment.data.year ||
            route.params.makeSlug != store.state.fitment.data.makeSlug ||
            route.params.modelSlug != store.state.fitment.data.modelSlug
        ) {
            const result = await store.dispatch('fitment/setFitmentFromUrl', {
                res,
                params: route.params,
            })

            if (!result) error({ statusCode: 404, message: 'Invalid Make/Model from url' })
        }
    } else if (meta && meta.isFitable && store.state.fitment.data.makeSlug)
        await store.dispatch('fitment/clearFitment', res)
}
